import { render, staticRenderFns } from "./DealsReportPresentaciones.vue?vue&type=template&id=b413d858&"
import script from "./DealsReportPresentaciones.vue?vue&type=script&lang=js&"
export * from "./DealsReportPresentaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports